module.exports = __webpack_public_path__ + "img/alarm.22dfd47c.png";